/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */

import React from "react";
import { useParams, useNavigate } from 'react-router-dom';

import { useAuth, useDispatcher } from "../../components/AuthProvider"

import { MM } from "../../engine/model_manager";



function AccountContainer(props) {
  const dispatch = useDispatcher();
  const navigate = useNavigate();
  const results = useAuth();
  let { id } = useParams();
  

  let sim_model = results.simResults.simModel;
  let simAcct = sim_model.findAccountById(parseInt(id));
  let modelAcct = MM.findAccountByID(results.currentModel.model, id);
  //let categories = results.simResults.simModel.summary;
  //let timespan = results.simResults.timeSpan;



  function onSubmit(action) {
    dispatch(action);
    navigate(-1);
  }


  function onCancel() {
    navigate(-1);
  }



  return (
    <div>
      {React.cloneElement(props.children, {results, simAcct, modelAcct, onSubmit, onCancel})}
    </div>
  );
}


export default AccountContainer;

